export default "/optimism.c4a87b69eb69194501ab08c27f10715c.svg";